module.exports = __webpack_public_path__ + "img/crafty.d098c1dc.png";